import React, { useState, useEffect, useRef } from "react";
import { Search, ImageOff, Loader } from "lucide-react";

const foodData = {
  A: [
    { name: "Aloo Gobi" },
    { name: "Aloo Paratha" },
    { name: "Aloo Tikki" },
    { name: "Aloo Matar" },
    { name: "Aloo Bonda" },
    { name: "Appam" },
    { name: "Avial" },
    { name: "Aloo Poha" },
    { name: "Aloo Chaat" },
    { name: "Aloo Jeera" },
  ],
  B: [
    { name: "Biryani" },
    { name: "Butter Chicken" },
    { name: "Bhaji" },
    { name: "Bhatura" },
    { name: "Baingan Bharta" },
    { name: "Bhel Puri" },
    { name: "Bhindi Masala" },
    { name: "Barfi" },
    { name: "Boondi Ladoo" },
    { name: "Bread Pakora" },
  ],
  C: [
    { name: "Chicken Tikka Masala" },
    { name: "Chole Bhature" },
    { name: "Chicken 65" },
    { name: "Chana Masala" },
    { name: "Curry" },
    { name: "Chapati" },
    { name: "Chicken Korma" },
    { name: "Chicken Chettinad" },
    { name: "Coconut Chutney" },
  ],
  D: [
    { name: "Dal Makhani" },
    { name: "Dosa" },
    { name: "Dhokla" },
    { name: "Dal Tadka" },
    { name: "Dal Fry" },
    { name: "Dabeli" },
    { name: "Dum Aloo" },
    { name: "Dhansak" },
    { name: "Dahi Vada" },
    { name: "Double Ka Meetha" },
  ],
  E: [{ name: "Egg Curry" }, { name: "Egg Bhurji" }],
  F: [{ name: "Fish Curry" }, { name: "Fish Fry" }, { name: "Falooda" }],
  G: [
    { name: "Gulab Jamun" },
    { name: "Gajar Ka Halwa" },
    { name: "Gobi Manchurian" },
    { name: "Golgappa (Pani Puri)" },
    { name: "Gujarati Kadhi" },
    { name: "Gatte Ki Sabzi" },
  ],
  H: [
    { name: "Hyderabadi Biryani" },
    { name: "Halwa" },
    { name: "Haleem" },
    { name: "Handi Mutton" },
  ],
  I: [
    { name: "Idli" },
    { name: "Idiyappam" },
    { name: "Iyengar Bakery Biscuits" },
  ],
  J: [{ name: "Jalebi" }, { name: "Jalfrezi" }, { name: "Jeera Rice" }],
  K: [
    { name: "Kadai Chicken" },
    { name: "Kadhi" },
    { name: "Kulfi" },
    { name: "Kachori" },
    { name: "Kheer" },
    { name: "Korma" },
    { name: "Kadai Paneer" },
    { name: "Khichdi" },
    { name: "Kolhapuri Chicken" },
    { name: "Kofta" },
  ],
  L: [
    { name: "Lassi" },
    { name: "Luchi" },
    { name: "Litti Chokha" },
    { name: "Lemon Rice" },
    { name: "Laal Maas" },
  ],
  M: [
    { name: "Malai Kofta" },
    { name: "Masala Dosa" },
    { name: "Mutton Rogan Josh" },
    { name: "Momos" },
    { name: "Methi Thepla" },
    { name: "Mysore Pak" },
    { name: "Misal Pav" },
    { name: "Matar Paneer" },
    { name: "Murgh Makhani" },
    { name: "Mattar Kulcha" },
  ],
  N: [
    { name: "Naan" },
    { name: "Nihari" },
    { name: "Navratan Korma" },
    { name: "Neer Dosa" },
  ],
  P: [
    { name: "Paneer Tikka" },
    { name: "Pav Bhaji" },
    { name: "Palak Paneer" },
    { name: "Poha" },
    { name: "Paratha" },
    { name: "Puri" },
    { name: "Papdi Chaat" },
    { name: "Pakora" },
    { name: "Pongal" },
    { name: "Pesarattu" },
    { name: "Punjabi Samosa" },
  ],
  Q: [{ name: "Qeema" }, { name: "Qorma" }],
  R: [
    { name: "Rasmalai" },
    { name: "Raita" },
    { name: "Rajma" },
    { name: "Rava Dosa" },
    { name: "Roti" },
    { name: "Rogan Josh" },
    { name: "Rabri" },
    { name: "Rava Idli" },
    { name: "Rasgulla" },
  ],
  S: [
    { name: "Samosa" },
    { name: "Saag Paneer" },
    { name: "Sambar" },
    { name: "Shahi Paneer" },
    { name: "Sev Puri" },
    { name: "Shrikhand" },
    { name: "Seekh Kebab" },
    { name: "Shahi Tukda" },
    { name: "Spicy Chicken Curry" },
    { name: "Suji Halwa" },
  ],
  T: [
    { name: "Tandoori Chicken" },
    { name: "Tikka Masala" },
    { name: "Thali" },
    { name: "Tamarind Rice" },
    { name: "Tawa Pulao" },
    { name: "Tomato Rice" },
  ],
  U: [
    { name: "Upma" },
    { name: "Uttapam" },
    { name: "Undhiyu" },
    { name: "Usal Pav" },
  ],
  V: [
    { name: "Vada" },
    { name: "Vada Pav" },
    { name: "Vindaloo" },
    { name: "Vegetable Biryani" },
    { name: "Vegetable Pulao" },
    { name: "Vegetable Korma" },
  ],
  Y: [{ name: "Yakhni" }, { name: "Yakhni Pulao" }],
  Z: [{ name: "Zafrani Pulao" }, { name: "Zeera Rice" }],
};

const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const UNSPLASH_ACCESS_KEY = "z9t1LOdrMzSMN2N-ctpFnDrTNUvDACdPLsS4lwUEWRk";

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(to bottom right, #fff7ed, #fef3c7)",
    padding: "24px",
  },
  wrapper: {
    maxWidth: "1280px",
    margin: "0 auto",
  },
  header: {
    textAlign: "center",
    marginBottom: "32px",
  },
  title: {
    fontSize: "2.25rem",
    fontWeight: "bold",
    color: "#9a3412",
    marginBottom: "8px",
  },
  subtitle: {
    color: "#ea580c",
  },
  card: {
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    padding: "24px",
    marginBottom: "24px",
  },
  searchContainer: {
    position: "relative",
    marginBottom: "24px",
  },
  searchInput: {
    width: "100%",
    paddingLeft: "40px",
    paddingRight: "16px",
    paddingTop: "12px",
    paddingBottom: "12px",
    border: "2px solid #fed7aa",
    borderRadius: "8px",
    outline: "none",
    fontSize: "16px",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    top: "12px",
    color: "#9ca3af",
  },
  buttonGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginBottom: "24px",
  },
  button: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  buttonActive: {
    backgroundColor: "#f97316",
    color: "white",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    transform: "scale(1.1)",
  },
  buttonAvailable: {
    backgroundColor: "#ffedd5",
    color: "#9a3412",
  },
  buttonDisabled: {
    backgroundColor: "#f3f4f6",
    color: "#9ca3af",
    cursor: "not-allowed",
  },
  resultsTitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#9a3412",
    marginBottom: "16px",
  },
  foodGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: "16px",
  },
  foodItem: {
    background: "linear-gradient(to right, #fff7ed, #fef3c7)",
    borderRadius: "8px",
    border: "1px solid #fed7aa",
    transition: "all 0.2s",
    overflow: "hidden",
    cursor: "pointer",
  },
  imageContainer: {
    width: "100%",
    height: "200px",
    backgroundColor: "#f3f4f6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
  },
  foodImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  imagePlaceholder: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    color: "#9ca3af",
  },
  foodContent: {
    padding: "16px",
  },
  foodText: {
    color: "#7c2d12",
    fontWeight: "600",
    margin: 0,
    fontSize: "1rem",
  },
  emptyState: {
    textAlign: "center",
    padding: "48px 0",
    color: "#6b7280",
  },
  loader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    color: "#f97316",
  },
};

export default function IndianFoodFilter() {
  const [selectedLetter, setSelectedLetter] = useState("A");
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [imageErrors, setImageErrors] = useState({});
  const [images, setImages] = useState({});
  const [loadingImages, setLoadingImages] = useState({});
  const abortControllerRef = useRef(null);
  const debounceTimerRef = useRef(null);

  // Debounce search term to prevent excessive API calls
  useEffect(() => {
    // Clear previous timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    // Set new timer
    debounceTimerRef.current = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500); // Wait 500ms after user stops typing

    // Cleanup
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [searchTerm]);

  const getFilteredFoods = () => {
    if (debouncedSearchTerm) {
      const allFoods = Object.values(foodData).flat();
      return allFoods.filter((food) =>
        food.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      );
    }
    return foodData[selectedLetter] || [];
  };

  const filteredFoods = getFilteredFoods();
  const availableLetters = Object.keys(foodData);

  // Fetch images from Unsplash API when filteredFoods changes (only after debounce)
  useEffect(() => {
    // Cancel previous requests
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    const fetchImagesForFoods = async () => {
      // Only fetch images for foods that don't have images yet and haven't errored
      const foodsToFetch = filteredFoods.filter(
        (food) => !images[food.name] && !imageErrors[food.name]
      );

      if (foodsToFetch.length === 0) return;

      // Set loading state for these foods
      setLoadingImages((prev) => {
        const newLoading = { ...prev };
        foodsToFetch.forEach((food) => {
          newLoading[food.name] = true;
        });
        return newLoading;
      });

      // Fetch images one by one to avoid rate limiting
      for (const foodItem of foodsToFetch) {
        if (abortController.signal.aborted) break;

        try {
          const response = await fetch(
            `https://api.unsplash.com/search/photos?query=indian%20food%20${encodeURIComponent(
              foodItem.name
            )}&per_page=1&client_id=${UNSPLASH_ACCESS_KEY}`,
            { signal: abortController.signal }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();

          if (
            data.results &&
            data.results[0] &&
            data.results[0].urls &&
            data.results[0].urls.small
          ) {
            setImages((prev) => ({
              ...prev,
              [foodItem.name]: data.results[0].urls.small,
            }));
          } else {
            // No image found, mark as error to avoid retrying
            setImageErrors((prev) => ({
              ...prev,
              [foodItem.name]: true,
            }));
          }
        } catch (error) {
          if (error.name === "AbortError") {
            console.log("Fetch aborted");
            break;
          }
          console.error("Error fetching image for", foodItem.name, error);
          setImageErrors((prev) => ({
            ...prev,
            [foodItem.name]: true,
          }));
        } finally {
          setLoadingImages((prev) => ({
            ...prev,
            [foodItem.name]: false,
          }));
        }

        // Small delay to avoid rate limiting
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
    };

    // Only fetch if we have filtered foods
    if (filteredFoods.length > 0) {
      fetchImagesForFoods();
    }

    return () => {
      abortController.abort();
    };
  }, [filteredFoods, images, imageErrors]);

  const getButtonStyle = (letter) => {
    const baseStyle = { ...styles.button };
    if (selectedLetter === letter && !debouncedSearchTerm) {
      return { ...baseStyle, ...styles.buttonActive };
    }
    if (availableLetters.includes(letter)) {
      return { ...baseStyle, ...styles.buttonAvailable };
    }
    return { ...baseStyle, ...styles.buttonDisabled };
  };

  const handleImageError = (foodName) => {
    setImageErrors((prev) => ({ ...prev, [foodName]: true }));
    setLoadingImages((prev) => ({ ...prev, [foodName]: false }));
  };

  // Fallback image URL using Lorem Picsum with deterministic seed
  const getFallbackImageUrl = (foodName) => {
    return `https://picsum.photos/seed/${encodeURIComponent(foodName)}/400/300`;
  };

  const handleLetterClick = (letter) => {
    setSelectedLetter(letter);
    setSearchTerm(""); // Clear search input
    setDebouncedSearchTerm(""); // Clear debounced search term immediately
  };

  return (
    <div style={styles.container}>
      <div style={styles.wrapper}>
        <div style={styles.header}>
          <h1 style={styles.title}>Authentic Bharat Cuisines</h1>
          <p style={styles.subtitle}>
            Explore delicious Indian dishes alphabetically
          </p>
        </div>

        <div style={styles.card}>
          <div style={styles.searchContainer}>
            <Search style={styles.searchIcon} size={20} />
            <input
              type="text"
              placeholder="Search for a dish (e.g., Biryani, Dosa, Paneer)..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={styles.searchInput}
              onFocus={(e) => (e.target.style.borderColor = "#fb923c")}
              onBlur={(e) => (e.target.style.borderColor = "#fed7aa")}
            />
          </div>

          <div style={styles.buttonGrid}>
            {alphabet.map((letter) => (
              <button
                key={letter}
                onClick={() => handleLetterClick(letter)}
                disabled={!availableLetters.includes(letter)}
                style={getButtonStyle(letter)}
                onMouseEnter={(e) => {
                  if (availableLetters.includes(letter)) {
                    e.target.style.backgroundColor = "#fdba74";
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedLetter === letter && !debouncedSearchTerm) {
                    e.target.style.backgroundColor = "#f97316";
                  } else if (availableLetters.includes(letter)) {
                    e.target.style.backgroundColor = "#ffedd5";
                  }
                }}
              >
                {letter}
              </button>
            ))}
          </div>

          {debouncedSearchTerm && (
            <div
              style={{ marginTop: "16px", color: "#ea580c", fontSize: "14px" }}
            >
              Showing results for: <strong>{debouncedSearchTerm}</strong>
              {filteredFoods.length === 0 && " - No dishes found"}
            </div>
          )}
        </div>

        <div style={styles.card}>
          {filteredFoods.length > 0 ? (
            <div style={styles.foodGrid}>
              {filteredFoods.map((food, index) => (
                <div
                  key={`${food.name}-${index}`}
                  style={styles.foodItem}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 4px 8px rgba(0,0,0,0.15)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <div style={styles.imageContainer}>
                    {loadingImages[food.name] ? (
                      <div style={styles.loader}>
                        <Loader size={32} className="animate-spin" />
                        <span>Loading image...</span>
                      </div>
                    ) : !imageErrors[food.name] ? (
                      <img
                        src={
                          images[food.name] || getFallbackImageUrl(food.name)
                        }
                        alt={food.name}
                        style={styles.foodImage}
                        onError={() => handleImageError(food.name)}
                        loading="lazy"
                      />
                    ) : (
                      <div style={styles.imagePlaceholder}>
                        <ImageOff size={48} />
                        <span style={{ fontSize: "0.875rem" }}>
                          Image not available
                        </span>
                      </div>
                    )}
                  </div>
                  <div style={styles.foodContent}>
                    <p style={styles.foodText}>{food.name}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={styles.emptyState}>
              <p style={{ fontSize: "1.125rem" }}>No dishes found</p>
              {debouncedSearchTerm && (
                <p style={{ fontSize: "0.875rem", marginTop: "8px" }}>
                  Try searching for something else like "Biryani", "Dosa", or
                  "Paneer"
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
